import { Button } from '@mui/material';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import { useUrlState } from '../urlState';
import { useAssistantAvailable } from './hooks';

export const CHAT_PARAM = 'chat';

export function AskAssistantButton() {
  const available = useAssistantAvailable();
  const { set } = useUrlState();
  if (!available) return null;
  return (
    <Button size="small" variant="outlined" startIcon={<ForumOutlinedIcon />} onClick={() => set({ [CHAT_PARAM]: '1' })}>
      Ask about this household
    </Button>
  );
}
